import classNames from 'classnames';
import { times } from 'lodash-es';
import React from 'react';
import styles from './DotSteppers.module.css';

export type DotSteppersProps = {
  activeIndex: number;
  steps: number;
  size?: number;
};

const DotSteppers = ({ activeIndex, steps, size = 6 }: DotSteppersProps) => {
  const dots = times(steps, index => (
    <div
      key={index}
      className={classNames(styles.dot, {
        [styles.active]: activeIndex === index,
      })}
      style={{ height: size, width: size }}
    />
  ));

  return <div className={styles.container}>{dots}</div>;
};

export default DotSteppers;
